import HttpUtils from '../utils/HttpUtils'

//注册
const register = (data: {
  phone: string,
  nickName?: string,
  password: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/register", data)
}

//忘记密码
const forgetPwd = (data: {
  phone: string,
  password: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/resetPassword", data)
}

// 发送验证码
const sendPhoneCode = (phone: string) => {
  return HttpUtils.post("/qzkt/user/phoneMsg/send?phone=" + phone)
}

// 发送验证码
const login = (data: {
  phone: string,
  password: string
}) => {
  return HttpUtils.post("/qzkt/user/login", data)
}

const logout = () => {
  ///qzkt/user/quit
  return HttpUtils.post("/qzkt/user/quit")
}

// phone:phoneNum,
// captcha,
// captchaKey: captchaKey.val()
const sendSmsV1 = (data:{
  phone:string,
  captcha:string,
  captchaKey:string
})=>{
  return HttpUtils.post("/qzkt/sms/send/v1", data)
}

//qzkt/sms/captcha
const getSmsCaptcha = ()=>{
  return HttpUtils.get("/qzkt/sms/captcha")
}
const getWechatLoginQrCode = ()=>{
  return HttpUtils.get("/qzkt/wx/web/login-qrcode-url")
}

// 短信直接登录
const loginBySms = (data: {
  phone: string,
  code: string
}) => {
  return HttpUtils.post("/qzkt/user/loginBySms", data)
}

const UserService = {
  register,
  sendPhoneCode,
  login,
  logout,
  forgetPwd,
  sendSmsV1,
  getSmsCaptcha,
  getWechatLoginQrCode,
  loginBySms
  
}

export default UserService;